import mapper from '@/common/store/mapper/index.js';
import { mapGetters, mapActions } from 'vuex';
import ArticlePresentational from './mvt-article.presentational.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';

export default {
    name: 'mvtArticleGrid',
    components: {
        ArticlePresentational,
        mvtLazyload,
    },
    data() {
        return {
            relatedArticles: [],
        };
    },
    props: {
        data: {
            type: Array,
            default() {
                return [];
            },
        },
        category: {
            type: Array,
            default: [],
        },
        tag: {
            type: Array,
            default: [],
        },
        limit: {
            type: [String, Number],
            default: 10,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    mounted() {
        if (this.data && this.data.length > 0) {
            this.relatedArticles = this.data;
            this.completed();
        } else {
            let requests = [];
            if (this.category.length > 0) {
                this.category.forEach((category, index) => {
                    requests.push(this.fetchArticleFeeds({ category: category, tag: this.tag[index] || undefined, limit: this.limit }));
                });
            } else if (this.tag.length > 0) {
                this.tag.forEach((tag) => {
                    requests.push(this.fetchArticleFeeds({ tag: tag, limit: this.limit }));
                });
            } else {
                requests.push(this.fetchArticleFeeds({ limit: this.limit }));
            }

            Promise.all(requests).then((data) => {
                let results = data.flat();
                if (results.length > 0) {
                    this.relatedArticles = mapper.article(results);
                    this.completed();
                }
            });
        }
    },
    methods: {
        ...mapActions('glb', ['fetchArticleFeeds']),
        completed() {
            this.$refs.lazyload.ready();
        },
    },
};
